<template>
  <b-card
    class="site-item"
    @click="
      $router.push({
        name: 'site.view-site-page',
        params: { id: site.site_id, name: site.name }
      })
    "
  >
    <div class="image-container">
      <b-img-lazy
        class="rounded-0 w-100"
        v-bind="mainProps"
        :src="site.banner ? site.banner.url : ''"
      ></b-img-lazy>
    </div>

    <div class="card-details-container mt-2">
      <div class="maintext ellipsis">{{ site.name }}</div>
      <div class="subtext">{{ site.address }}</div>
      <compliance-list :site="site" />
    </div>
  </b-card>
</template>

<script>
import Site from '@/models/Site'
import ComplianceList from '@/components/lists/site/ComplianceList'

export default {
  components: {
    ComplianceList
  },

  props: {
    site: {
      type: [Site, Object],
      required: true
    }
  },

  data() {
    return {
      mainProps: {
        center: true,
        blank: true,
        height: '136px',
        width: 'auto'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.site-item /deep/ {
  .compliance-list {
    font-size: 0.925em;
  }
}
.card-body {
  padding: 12px;
}
.card:hover {
  box-shadow: 4px 4px 25px #a9a9a9;
  cursor: pointer;
}
.image-container {
  background-color: black;
  border-radius: 10px;
  overflow: hidden;
}
.card-details-container {
  background-color: white;
}
.maintext {
  font-weight: bold;
  font-size: 18px;
}
.subtext {
  font-size: 16px;
  margin-bottom: 0.25rem;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.5em;
  max-height: calc(1.5em * 2);
}
.compliance-list {
  padding-top: 5px;
}
</style>
